<style lang="scss" scoped>
.v-icon {
  width: 20px;
}

article {
  align-items: center;
  display: inline-flex;
  margin-left: 10px;
}

.grade {
  font-size: 0.75rem;
  margin-left: 0.25rem;
}
</style>

<template>
  <article>
    <template v-if="loaded">
      <template>
        <dr-icon name="starAvaliacao" color="#ffb700"></dr-icon>
        <span class="grade">
          {{ grade }}
        </span>
      </template>
    </template>
    <dr-loader v-else></dr-loader>
  </article>
</template>

<script>
export default {
  data () {
    return {
      loaded: false,
      grade: null
    }
  },
  mounted () {
    this.$http.get(`/doctor/doctor_grade`, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.grade = (res.data.doctorGradesAverage)
          ? `${res.data.doctorGradesAverage}pts`
          : 'Sem avaliação'
        this.loaded = true
      }
    )
  }
}
</script>
